module.exports = __webpack_public_path__ + "img/ic_reset_chart.8b451951.svg";